import React from "react";

const AddMarketPlace = ({ isOpen, setOpen }) => {
  return (
    <div>
      <div
        id="confirmation-modal"
        aria-hidden="true"
        className={`${
          isOpen ? "fixed" : "hidden"
        }  inset-0 z-50 flex items-center justify-center`}
      >
        <div className="absolute inset-0 bg-gray-800 opacity-75"></div>
        <div className="relative w-screen  max-w-md h-full md:h-auto">
          <div className=" rounded-lg shadow relative border border-mark  bg-[#F5F5F5]">
            <div className="flex justify-between p-2">
              <h1 className=" text-lg"> Add Marketplace</h1>
              <button
                type="button"
                className="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center :hover:bg-gray-800 :hover:text-white"
                onClick={() => setOpen(false)}
              >
                <svg
                  className="w-5 h-5"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                    clipRule="evenodd"
                  ></path>
                </svg>
              </button>
            </div>
            <div className="w-full flex flex-col  h-full  mb-2 gap-2 p-3">
              <div className=" grid grid-cols-2 gap-6">
                <div>
                  <h1>Product name</h1>
                  <input type="text" className=" py-1 rounded-md" />
                </div>
                <div>
                  <h1>Category</h1>
                  <input type="text" className=" py-1 rounded-md" />
                </div>
                <div>
                  <h1>Brand</h1>
                  <input type="text" className=" py-1 rounded-md" />
                </div>
                <div>
                  <h1>Price</h1>
                  <input type="text" className=" py-1 rounded-md" />
                </div>
              </div>
              <div>
                <h1>Price</h1>
                <input type="text" className=" py-1 rounded-md w-full" />
              </div>
              <div>
                <h1>Price</h1>
                <textarea
                  cols={3}
                  type="text"
                  className=" py-1 rounded-md w-full"
                />
              </div>
              <h1>Price</h1>
              <div className="relative w-full">
                <div className="absolute top-0 left-0 bg-white p-2 rounded-md w-full text-center border-2 border-[#00BF63] border-dashed">
                  <h1 className=" text-xs">Upload image (png,jpg,jpeg)</h1>
                </div>

                <input type="file" className="py-1 rounded-md" />
              </div>
            </div>
            <div className="flex justify-center">
              <div className="bg-[#013220] text-white py-2 text-center rounded-md w-72 mb-5">
                Upload Post
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddMarketPlace;
